import { render, staticRenderFns } from "./DischargeSummary.vue?vue&type=template&id=ee5ad12c&scoped=true&"
import script from "./DischargeSummary.vue?vue&type=script&lang=js&"
export * from "./DischargeSummary.vue?vue&type=script&lang=js&"
import style0 from "./DischargeSummary.vue?vue&type=style&index=0&id=ee5ad12c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ad12c",
  null
  
)

export default component.exports